import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { LayoutState } from '../type';

/**
 * Chrome state for the app shell.
 *
 * Only `sidebarCollapsed` is persisted: it is a deliberate user preference, while
 * an overlay left open on a phone should not still be open on the next visit.
 * `partialize` is what draws that line.
 */
export const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      mobileSidebarOpen: false,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      setMobileSidebarOpen: (mobileSidebarOpen) => set({ mobileSidebarOpen }),
    }),
    {
      name: 'rf-layout',
      partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }),
    }
  )
);
